import { useRef, useEffect } from "react"
import "./common.css"
import floatingMenuIcon from "../../../../assets/icons/FloatingMenu/floatingMenuIcon.png"
import watchGray from "../../../../assets/icons/FloatingMenu/watchGray.png"
import watchBlack from "../../../../assets/icons/FloatingMenu/watchBlack.png"
import classicGray from "../../../../assets/icons/FloatingMenu/classicGray.png"
import classicBlack from "../../../../assets/icons/FloatingMenu/classicBlack.png"
import ultraWhite from "../../../../assets/icons/FloatingMenu/ultraWhite.png"
import ultraBlack from "../../../../assets/icons/FloatingMenu/ultraBlack.png"
import ultraOrange from "../../../../assets/icons/FloatingMenu/ultraOrange.png"
import watch8Classic from "../../../../assets/icons/FloatingMenu/watch8Classic.png"
import watch8General from "../../../../assets/icons/FloatingMenu/watch8General.png"
import watch8Ultra from "../../../../assets/icons/FloatingMenu/watch8Ultra.png"
import watch8ClassicWhite from "../../../../assets/icons/FloatingMenu/watch8ClassicWhite.png"
import watch8GeneralBlack from "../../../../assets/icons/FloatingMenu/watch8GeneralBlack.png"

import { MENU_TYPE } from "../../utils/constants"

interface FloatingMenuSelector {
    type: string 
    isClick: boolean
    setIsClick: React.Dispatch<React.SetStateAction<boolean>> 
    setselectedWatchFrame: React.Dispatch<React.SetStateAction<string>>
}

export const FloatingWatchFrames = ( props: any ) => {
    let classicWatchImages = [
        {raw: watch8Classic, name: "watch8Classic"},
        {raw: watch8ClassicWhite, name: "watch8ClassicWhite"},
        {raw: classicGray,   name: "classicGray"}, 
        {raw: classicBlack,  name: "classicBlack"}
    ]
    let ultraWatchImages = [
        {raw: watch8Ultra,   name: "watch8Ultra"},
        {raw: ultraWhite,    name: "ultraWhite"},
        {raw: ultraBlack,    name: "ultraBlack"},
        {raw: ultraOrange,   name: "ultraOrange"},
    ]
    let generalWatchImages = [
        {raw: watch8GeneralBlack, name: "watch8GeneralBlack"},
        {raw: watch8General, name: "watch8General"},
        {raw: watchBlack,    name: "watchBlack"},
        {raw: watchGray,     name: "watchGray"}, 
    ]

    return (
        <div className="floating-menu-inside">
            <section className="flex flex-row gap-7 cursor-pointer">
                {
                    generalWatchImages.map( (image,idx) => (
                        <div 
                            key={`${idx}-${image.name}`}>
                            <img 
                                className="w-[26px] h-[37px]"
                                onClick={() => {props.setselectedWatchFrame(image.name); props.handleClick(false)}}
                                src={image.raw}
                                alt=""
                            />
                        </div>
                    ))
                }
            </section>
            <section className="flex flex-row gap-7 cursor-pointer">
                {
                    ultraWatchImages.map( (image,idx) => (
                        <div key={`${idx}-${image.name}`}>
                            <img 
                                className="w-[26px] h-[37px]"
                                onClick={() => {props.setselectedWatchFrame(image.name); props.handleClick(false)}}
                                src={image.raw}
                                alt=""
                            />
                        </div>
                    ))
                }
            </section>
            <section className="flex flex-row gap-7 cursor-pointer">   
                {
                    classicWatchImages.map( (image,idx) => (
                        <div key={`${idx}-${image.name}`}>
                            <img 
                                className="w-[26px] h-[37px]"
                                onClick={() => {props.setselectedWatchFrame(image.name); props.handleClick(false)}}
                                src={image.raw}
                                alt=""
                            />
                        </div>
                    ))
                }
            </section>
        </div>
    )
}

export const FloatingMenu = ( props: FloatingMenuSelector) => {
    const menuRef = useRef<HTMLDivElement>(null)

    const colorMap = {
        [MENU_TYPE.SAM_WATCH]: { to: "#1e40af", from: "#002b71"},
        [MENU_TYPE.YAM_WATCH]: { to: "#fcc92c", from: "#e5005e"}
    }
    const handleClick = (type: boolean) => {
        props.setIsClick(type);
        return
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                props.setIsClick(false)
            }
        }

        if (props.isClick) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [props.isClick, props.setIsClick])

    return (
        <div 
            ref={menuRef}
            className={props.isClick ? "floating-menu-open" : "floating-menu"}
            style={{ background: `linear-gradient(to right, ${colorMap[props.type].to}, ${colorMap[props.type].from})`}}
        >
            { 
                props.isClick ?  
                <FloatingWatchFrames 
                    handleClick={handleClick} 
                    setselectedWatchFrame={props.setselectedWatchFrame}
                /> 
                :   
                <img
                    onClick={ () => { handleClick(true) } }
                    className="floating-menu-icon"
                    src={floatingMenuIcon}                    
                    alt=""
                />
            }
        </div>
    )
}